export interface CurrencyPair {
  currency_id_from: number;
  currency_id_to: number;
  currency_type_from: "fiat" | "crypto";
  currency_type_to: "fiat" | "crypto";
  country_from: string;
  country_to: string;
}

export const currencyPairs: CurrencyPair[] = [
  {
    currency_id_from: 19,
    currency_id_to: 18,
    currency_type_from: "fiat",
    currency_type_to: "fiat",
    country_from: "us",
    country_to: "ru",
  },
  {
    currency_id_from: 25,
    currency_id_to: 18,
    currency_type_from: "crypto",
    currency_type_to: "fiat",
    country_from: "USDT",
    country_to: "ru",
  },
  {
    currency_id_from: 19,
    currency_id_to: 25,
    currency_type_from: "fiat",
    currency_type_to: "crypto",
    country_from: "us",
    country_to: "USDT",
  },
  {
    currency_id_from: 20,
    currency_id_to: 19,
    currency_type_from: "crypto",
    currency_type_to: "fiat",
    country_from: "bitcoin",
    country_to: "us",
  },
  {
    currency_id_from: 20,
    currency_id_to: 25,
    currency_type_from: "crypto",
    currency_type_to: "crypto",
    country_from: "bitcoin",
    country_to: "USDT",
  },
  {
    currency_id_from: 20,
    currency_id_to: 18,
    currency_type_from: "crypto",
    currency_type_to: "fiat",
    country_from: "bitcoin",
    country_to: "ru",
  },
];
